<ng-container *ngIf="state?.views !== null">
  <alliance-icon [inheritColor]="true" [name]="ICONS.IconViewEye20"></alliance-icon>
  <span class="santa-typo-additional santa-pl-10">{{ state?.views | prettyNumber }}</span>
</ng-container>
